import { Breadcrumb, Col, Row } from "antd";
import Title from "../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { TransactionList } from "./transactionList";

function Summarytables() {
  const { t } = useTranslation("common");
  return (
    <>
      <Row gutter={[0, 0]}>
        <Col
          offset={1}
          span={22}
          style={{
            marginBottom: "10px",
          }}
        >
          <Breadcrumb
            items={[
              {
                title: (
                  <Link to="" style={{ cursor: "not-allowed" }}>
                    {t("home")}
                  </Link>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {" "}
                    {t("till-information")}{" "}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        <Col offset={1} span={22}>
          <Title title={`${t("transaction-stats")}`} />
        </Col>
        <Col offset={1} span={22}>
          <TransactionList />
        </Col>
      </Row>
    </>
  );
}

export default Summarytables;
